import axios from "axios";
import queryString from "query-string";

const runtimeOrigin =
  process.env.REACT_APP_API_ORIGIN ||
  (typeof window !== "undefined" ? window.location.origin : "");

export const baseUrl = `${runtimeOrigin}/api/v1/`;
export const assetBaseUrl = `${runtimeOrigin}/`;
export const clientBaseUrl = `${runtimeOrigin}/`;

const getToken = () => localStorage.getItem("token");

const axiosClient = axios.create({
  baseURL: baseUrl,
  paramsSerializer: {
    serialize: (params) => queryString.stringify({ params }),
  },
});

axiosClient.interceptors.request.use(async (config) => {
  return {
    ...config,
    headers: {
      "Content-Type": "application/json",
      authorization: `Bearer ${getToken()}`,
    },
  };
});

axiosClient.interceptors.response.use(
  (response) => {
    if (response && response.data) return response.data;

    return response;
  },
  (err) => {
    if (!err.response) {
      alert(err);
    }
    throw err.response;
  }
);

export default axiosClient;
